import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as Sentry from '@sentry/browser';

if (window.appConfig.sentryDsn) {
  Sentry.init({
    dsn: window.appConfig.sentryDsn,
    release: window.appConfig.release ?? undefined,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: 0.1,
  });
}

ReactDOM.render(<App />, document.getElementById('root'));
